// 退款操作
import useTalkAvailable from 'hooks/business/useTalkAvailable';
import { useTranslate } from '@tolgee/react';
import { ReturnActionsProps } from './types';
import { ReturnActionLazada } from './ReturnActionLazada';
import { ReturnActionShopee } from './ReturnActionShopee';
import { isTiKTokUpperCase } from 'lib/utils/isTikTok';
import { ReturnActionTikTok } from './ReturnActionTikTok';
import { memo } from 'react';
import { ReturnActionMercado } from './ReturnActionMercado';
import { ReturnActionKwai } from './ReturnActionKwai';

export const ReturnActions = memo((props: ReturnActionsProps) => {
  const { conversation, platform } = props;
  const { t } = useTranslate();
  const available = useTalkAvailable(conversation);

  if (available) {
    if (platform === 'SHOPEE') {
      return <ReturnActionShopee {...props} />;
    }

    if (platform === 'LAZADA') {
      return <ReturnActionLazada {...props} />;
    }

    if (isTiKTokUpperCase(platform)) {
      return <ReturnActionTikTok {...props} />;
    }
    if (platform === 'MERCADO') {
      const {
        row: { unit, refundAmount, externalStoreId, orderSn, returnSn, operate, internalStoreId },
        refreshList,
      } = props;
      return (
        <ReturnActionMercado
          unit={unit}
          refundAmount={refundAmount}
          externalStoreId={externalStoreId}
          externalTradeId={orderSn}
          internalStoreId={internalStoreId}
          returnSn={returnSn}
          operate={operate}
          platform={platform}
          refreshList={refreshList}
        />
      );
    }
    if (platform === 'KWAI') {
      return <ReturnActionKwai {...props} />;
    }
  }

  return (
    <>
      {conversation?.receptionName
        ? t('scene.orderWorkspace.returnRefundTab.detail.hint.forwarded', {
            name: conversation.receptionName,
          })
        : '-'}
    </>
  );
});
